import { lazy } from 'react';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import { PrivateRoute } from '@/hooks/useAuth';
import EBasicActions from '@/enums/EBasicActions';

const CustomFieldsPage = lazy(() => import('@/containers/Views/CustomFields/CustomFieldsPage'));

const routeElement = (
  <PrivateRoute
    pageName={EPage.CustomFields}
    permissions={EBasicActions.Find}
  >
    <CustomFieldsPage />
  </PrivateRoute>
);

const CustomFieldsRouter = (
  <Route path="custom_fields">
    <Route index element={routeElement} />
  </Route>
);

export default CustomFieldsRouter;
